export default __webpack_public_path__ + "static/media/congrats-laptop.4a8b6acc.svg";